import { useTheme } from '@emotion/react';
import { Card, CardContent, CardHeader, CardMedia } from '@mui/material';
import { useYoutubeVideoData } from '../../hooks/useYoutubeVideoData/useYoutubeVideoData';
import {
  fontSize14Sx,
  headerActionBtnSx,
  mediaCardHeaderSx,
  mediaCardSx,
  mediaCardTypographySx,
} from '../../styles/Global.style';
import { Text } from '../Text/Text';
import { ModalContainer } from '../../containers/ModalContainer/ModalContainer';
import { Confirmation } from '../Confirmation/Confirmation';
import { deleteVideo } from '../../helpers/deleteVideo';
import { IconBtn } from '../IconBtn/IconBtn';
import { Delete } from '@mui/icons-material';
import { useState } from 'react';
import { useAuth } from '../../hooks/useAuth/useAuth';
import { Copy } from '../../copy/Copy';

export const VideoCard = ({
  videoId,
  youtubeId,
  userId,
  onLoad,
  visibility,
}) => {
  const theme = useTheme();
  const { user } = useAuth();
  const { videoData } = useYoutubeVideoData(youtubeId);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  const toggleDeleteModal = () => {
    setIsDeleteModalOpen(!isDeleteModalOpen);
  };

  const handleDelete = async (e) => {
    e.preventDefault();
    await deleteVideo({
      jwt: user?.jwt,
      videoId,
    });
    location.reload();
  };

  return (
    <>
      <Card sx={{ ...mediaCardSx(theme), visibility }}>
        <CardHeader
          title={videoData?.author_name}
          sx={mediaCardHeaderSx(theme)}
          titleTypographyProps={mediaCardTypographySx}
          action={
            userId === user?.id && (
              <IconBtn
                icon={<Delete sx={headerActionBtnSx} />}
                aria-label="Delete video"
                onClick={toggleDeleteModal}
                color={theme.palette.secondary.main}
              />
            )
          }
        />
        <CardMedia
          component="iframe"
          src={`https://www.youtube-nocookie.com/embed/${youtubeId}`}
          height="194"
          title={videoData?.title}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          onLoad={onLoad}
          allowFullScreen
        />
        <CardContent>
          <Text variant="body2" text={videoData?.title} sx={fontSize14Sx} />
        </CardContent>
      </Card>

      <ModalContainer isOpen={isDeleteModalOpen} onClose={toggleDeleteModal}>
        <Confirmation
          title={Copy.generate('Global.areYouSure')}
          content={Copy.generate('VideoCard.deleteModal.content')}
          acceptBtnText={Copy.generate('Buttons.delete')}
          declineBtnText={Copy.generate('Buttons.back')}
          accept={handleDelete}
          decline={toggleDeleteModal}
        />
      </ModalContainer>
    </>
  );
};
